import type { Remote } from '@gohighlevel/ghl-module-federation-plugin'
import config from '../config/runtimeRemoteApps'
import { initFederation } from '@gohighlevel/ghl-module-federation-plugin'

const remoteApps: Remote[] = []
Object.keys(config).forEach(key => {
    remoteApps.push({
        name: key,
        alias: key,
        entry: config[key]
    })
})

initFederation({
    name: 'spm-ts-runtime-remote-apps',
    remotes: remoteApps
})
